"use strict";

var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LongColorCSSPropertyValidator = void 0;
var _LongForgivingCSSPropertyValidator = require("./LongForgivingCSSPropertyValidator");
var COLOR_REGEX = /^(rgb|rgba|hsl|hsla)\([\d,%. ]+\)|[#]?\w+$/;
var LongColorCSSPropertyValidator = /*#__PURE__*/function (_LongForgivingCSSProp) {
  _inherits(LongColorCSSPropertyValidator, _LongForgivingCSSProp);
  var _super = _createSuper(LongColorCSSPropertyValidator);
  function LongColorCSSPropertyValidator() {
    _classCallCheck(this, LongColorCSSPropertyValidator);
    return _super.apply(this, arguments);
  }
  _createClass(LongColorCSSPropertyValidator, [{
    key: "normalizeRawInlineCSSValue",
    value: function normalizeRawInlineCSSValue(value) {
      return value.match(COLOR_REGEX) ? value : null;
    }
  }]);
  return LongColorCSSPropertyValidator;
}(_LongForgivingCSSPropertyValidator.LongForgivingCSSPropertyValidator);
exports.LongColorCSSPropertyValidator = LongColorCSSPropertyValidator;